// JsFromRoutes CacheKey 307f517dadb80fa8f02179f8a57f21bd
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  archive: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/bookings/:id/archive"),
  unarchive: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/bookings/:id/unarchive"),
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/bookings"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/bookings"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/bookings/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/bookings/:id"),
}
